import { render } from "./WizardView.vue?vue&type=template&id=34ded055&scoped=true&ts=true"
import script from "./WizardView.vue?vue&type=script&lang=ts"
export * from "./WizardView.vue?vue&type=script&lang=ts"

import "./WizardView.vue?vue&type=style&index=0&id=34ded055&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34ded055"]])

export default __exports__